<template>
  <div style="margin-top: -0.6rem">
    <div class="serve-flex-col serve-flex-auto group_3">
      <div class="serve-flex-col group_4 space-y-50">
        <span class="serve-self-center text_10"
          >民营物流企业发展作用突出 行业集中度进一步提升</span
        >
        <div class="serve-flex-row serve-justify-center">
          <span class="font_3 text_11">发布时间：2023年08月04日11:04</span>
          <span class="font_3 text_12">来源： 央视网</span>
        </div>
      </div>
      <div class="serve-flex-col serve-self-center group_5">
        <span class="font_2 text_13">
          央视网消息：中国物流与采购联合会昨天（8月3日）发布了2023年度中国物流企业50强。从物流业务收入占比来看，50强物流企业的物流业务收入占物流业总收入的比重升至历年最高，并且50强物流企业门槛大幅提高，显示物流行业发展韧性较强，行业集中度进一步提高。
          <br />
        </span>
        <span class="font_2 text_14">
          据统计，50强物流企业2022年物流业务收入合计23456亿元，同比增长13.4%；50强物流企业门槛77.4亿元，比上年提高15.8亿元；50强物流企业物流业务收入合计占物流业总收入的比重升至18%，为历年最高水平。从结构看，物流业务收入千亿级的企业增加至5家，百亿级企业增加至34家，合计占比近八成，百亿级企业数量成为中坚力量，行业聚集效应持续显现，物流行业市场集中度进一步提升。
          <br />
        </span>
        <span class="serve-self-start font_2 text_15">
          另外，民营物流企业发展作用突出。在中国50强物流企业中，有19家是民营企业，并且占比持续提升，成为物流头部企业的重要主体。
        </span>
        <span class="font_2 text_14">
          从物流数字化水平来看，大多数50强中国物流企业都已迈过数字化转型的初期阶段，数字化赋能降本增效，成为头部物流企业盈利模式转型的重要途径。预计，2023年中国物流企业50强平均投资近亿元，同比增长近三成，有九成的企业投资同比增加。
        </span>
      </div>
      <div class="serve-flex-row serve-justify-center group_6 space-x-12">
        <img
          class="image_2"
          src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64d2ff7f95f17d0011c4015e/16922556527291973654.png"
        />
        <img
          class="image_3"
          src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64d2ff7f95f17d0011c4015e/16922556527328301785.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sort: 1,
    };
  },
};
</script> 

<style scoped>
/************************************************************
** 请将全局样式拷贝到项目的全局 CSS 文件或者当前页面的顶部 **
** 否则页面将无法正常显示                                  **
************************************************************/

html {
  font-size: 256px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.serve-flex-row {
  display: flex;
  flex-direction: row;
}

.serve-flex-col {
  display: flex;
  flex-direction: column;
}

.serve-justify-start {
  justify-content: flex-start;
}

.serve-justify-end {
  justify-content: flex-end;
}

.serve-justify-center {
  justify-content: center;
}

.serve-justify-between {
  justify-content: space-between;
}

.serve-justify-around {
  justify-content: space-around;
}

.serve-justify-evenly {
  justify-content: space-evenly;
}

.serve-items-start {
  align-items: flex-start;
}

.serve-items-end {
  align-items: flex-end;
}

.serve-items-center {
  align-items: center;
}

.serve-items-baseline {
  align-items: baseline;
}

.serve-items-stretch {
  align-items: stretch;
}

.serve-self-start {
  align-self: flex-start;
}

.serve-self-end {
  align-self: flex-end;
}

.serve-self-center {
  align-self: center;
}

.serve-self-baseline {
  align-self: baseline;
}

.serve-self-stretch {
  align-self: stretch;
}

.serve-flex-1 {
  flex: 1 1 0%;
}

.serve-flex-auto {
  flex: 1 1 auto;
}

.serve-grow {
  flex-grow: 1;
}

.serve-grow-0 {
  flex-grow: 0;
}

.serve-shrink {
  flex-shrink: 1;
}

.serve-shrink-0 {
  flex-shrink: 0;
}

.serve-relative {
  position: relative;
}
.image {
  width: 0.23rem;
  height: 0.14rem;
}
.font_2 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.14rem;
  color: #000000;
}
.group_3 {
  padding-top: 0.059rem;
  overflow-y: auto;
}
.section_2 {
  padding: 0.67rem 1.25rem 0.84rem;
  background-image: url("https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/63ff0d0c5a7e3f03109fe717/64d2ff7f95f17d0011c4015e/16922556527279212057.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.space-y-68 > *:not(:first-child) {
  margin-top: 0.27rem;
}
.text_8 {
  color: #ffffff;
  font-size: 0.23rem;
  font-family: PingFang;
  font-weight: 700;
  line-height: 0.22rem;
}
.text_9 {
  color: #ffffff;
  font-size: 0.1rem;
  font-family: PingFang;
  line-height: 0.1rem;
}
.group_4 {
  margin-top: 0.64rem;
}
.space-y-50 > *:not(:first-child) {
  margin-top: 0.2rem;
}
.text_10 {
  color: #383838;
  font-size: 0.13rem;
  font-family: PingFang;
  font-weight: 700;
  line-height: 0.12rem;
}
.font_3 {
  font-size: 0.059rem;
  font-family: SourceHanSansCN;
  line-height: 0.055rem;
  color: #383838;
}
.text_11 {
  font-size: 0.055rem;
  line-height: 0.051rem;
}
.text_12 {
  font-size: 0.055rem;
  line-height: 0.051rem;
}
.group_5 {
  margin-top: 0.25rem;
  width: 5.01rem;
}
.text_13 {
  font-size: 0.063rem;
  text-align: justify;
  text-indent: 0.13rem;
}
.text_14 {
  font-size: 0.063rem;
  text-align: justify;
  text-indent: 0.13rem;
}
.text_15 {
  margin-left: 0.13rem;
  font-size: 0.063rem;
}
.group_6 {
  margin-top: 0.41rem;
  padding: 0 1.24rem;
}
.space-x-12 > *:not(:first-child) {
  margin-left: 0.047rem;
}
.image_2 {
  width: 2.7rem;
  height: 1.19rem;
}
.image_3 {
  width: 2.27rem;
  height: 1.19rem;
}
.section_3 {
  margin-top: 2.34rem;
  padding: 0.21rem 0.38rem 0.25rem;
  background-color: #111111;
}
.space-y-18 > *:not(:first-child) {
  margin-top: 0.07rem;
}
.image_4 {
  margin-left: 2.11rem;
}
.group_7 {
  padding-left: 1.34rem;
}
.group_8 {
  width: 4.11rem;
}
.group_9 {
  margin-bottom: 0.016rem;
  width: 1.81rem;
}
.text_16 {
  color: #ffffff;
  font-size: 0.086rem;
  font-family: PingFang;
  font-weight: 700;
  line-height: 0.08rem;
}
.font_5 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.055rem;
  color: #ffffff;
}
.text_18 {
  margin-top: 0.07rem;
  line-height: 0.059rem;
  letter-spacing: 0.016rem;
}
.text_20 {
  margin-top: 0.055rem;
  letter-spacing: 0.0051rem;
}
.text_21 {
  margin-top: 0.031rem;
  letter-spacing: 0.025rem;
}
.group_10 {
  padding: 0 0.44rem;
  border-left: solid 0.002rem #ffffff;
}
.space-x-34 > *:not(:first-child) {
  margin-left: 0.13rem;
}
.image_5 {
  width: 0.41rem;
  height: 0.41rem;
}
.space-y-28 > *:not(:first-child) {
  margin-top: 0.11rem;
}
.font_4 {
  font-size: 0.059rem;
  font-family: PingFang;
  line-height: 0.055rem;
  font-weight: 700;
  color: #ffffff;
}
.text_17 {
  letter-spacing: 0.078rem;
}
.text_19 {
  color: #ffffff;
  font-size: 0.12rem;
  font-family: PingFang;
  font-weight: 700;
  line-height: 0.088rem;
}
.text_22 {
  font-size: 0.063rem;
  line-height: 0.059rem;
}
.text_23 {
  letter-spacing: 0.013rem;
}
</style>



// WEBPACK FOOTER //
// src/views/new3.vue